document.addEventListener("DOMContentLoaded", function () {
  var productGrids = document.querySelectorAll(".grid.product-grid");

  productGrids.forEach(function (productGrid) {
    var sectionId = productGrid.getAttribute("data-section-id");
    var variantDataMap =
      window["variantDataMap" + sectionId.replace(/-/g, "_")];

    // Función reutilizable: actualiza la imagen del card
    function updateCardImage(card, variantId) {
      if (!card || !variantId) return;

      var variantData = variantDataMap && variantDataMap[variantId];
      if (!variantData) {
        console.log("No data found for variant:", variantId);
        return;
      }

      var productImageElement = card.querySelector(".card__media img");
      if (!productImageElement) {
        console.log("No product image element found in this card.");
        return;
      }

      var lazyLoadAllVariants =
        card.getAttribute("data-lazy-load-all-variants") === "true";

      if (lazyLoadAllVariants) {
        var preloadedImage = card.querySelector(
          'img[data-variant-id="' + variantId + '"]'
        );
        if (preloadedImage) {
          productImageElement.src = preloadedImage.src;
          productImageElement.srcset = preloadedImage.srcset;
        } else {
          console.log(
            "Matching preloaded image not found for variant:",
            variantId
          );
        }
      } else {
        // Update src and srcset for responsive images
        var dynamicSrcset = [
          variantData.imageUrl + "?width=165 165w",
          variantData.imageUrl + "?width=360 360w",
          variantData.imageUrl + "?width=533 533w",
          variantData.imageUrl + "?width=720 720w",
          variantData.imageUrl + "?width=940 940w",
          variantData.imageUrl + "?width=1066 1066w",
        ].join(", ");

        productImageElement.srcset = dynamicSrcset;
        productImageElement.src = variantData.imageUrl;
      }
    }

    // ✅ Comportamiento actual: change (click en el radio del swatch)
    productGrid.addEventListener("change", function (e) {
      if (
        e.target.matches(
          'input[type="radio"][data-section-id="' + sectionId + '"]'
        )
      ) {
        var card = e.target.closest(
          '.card-product-custom-div[data-section-id="' + sectionId + '"]'
        );
        var variantId = e.target.getAttribute("data-variant-id");

        if (!card || !variantId) return;

        // Cambiar imagen
        updateCardImage(card, variantId);

        // Cambiar URL del producto solo en change
        var variantData = variantDataMap && variantDataMap[variantId];
        if (!variantData) {
          console.log("No data found for variant:", variantId);
          return;
        }

        var productLinks = card.querySelectorAll(
          'a[id^="CardLink-"], a[id^="StandardCardNoMediaLink-"]'
        );
        productLinks.forEach(function (link) {
          link.href = variantData.productUrl;
        });
      } else {
        console.log("Change detected, but not on a swatch.");
      }
    });

    // 🖱️ Nuevo: cambiar imagen también en hover (mouseover) del swatch
    productGrid.addEventListener("mouseover", function (e) {
      // opcional: no hacer nada en pantallas chicas
      if (window.innerWidth < 768) return;

      var target = e.target;

      // 1) Intentar si el hover fue directamente sobre el input
      var hoveredInput = target.closest(
        'input[type="radio"][data-section-id="' + sectionId + '"]'
      );

      // 2) Si no fue el input, intentar con el label del swatch
      if (!hoveredInput) {
        // asumiendo que tus labels tienen la clase "color-swatch"
        var swatchLabel = target.closest("label.color-swatch");
        if (swatchLabel) {
          var inputId = swatchLabel.getAttribute("for");
          if (inputId) {
            hoveredInput = productGrid.querySelector("#" + inputId);
          }
        }
      }

      if (!hoveredInput) return;

      var card = hoveredInput.closest(
        '.card-product-custom-div[data-section-id="' + sectionId + '"]'
      );
      var variantId = hoveredInput.getAttribute("data-variant-id");

      if (!card || !variantId) return;

      // Solo actualizamos IMAGEN en hover (no la URL)
      updateCardImage(card, variantId);
    });
  });
});
